const groupBy = <T extends { [key: string]: any }>(
  objects: T[],
  key: keyof T,
): { [key: string]: T[] } =>
  objects.reduce((map, obj) => {
    // eslint-disable-next-line no-param-reassign
    map[obj[key]] = map[obj[key]] || [];
    map[obj[key]].push(obj);

    return map;
  }, {} as { [key: string]: T[] });

export default groupBy;

export const range = (from: number, to: number) =>
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
  [...Array(to - from)].map((_, i) => from + i);

export const unixTimeToString = (unixtime: number): string => {
  const date = new Date(unixtime * 1000);
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const day = date.getDate().toString().padStart(2, '0');

  return `${date.getFullYear()}/${month}/${day}`;
};
